import * as React from 'react'
import LayoutOrg from '../components/organisms/common/layout'
import Helmet from 'react-helmet'
import ProfileOrg from '../components/organisms/home/profile'
import ContactMol from '../components/molecules/contact'

export default class Home extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>滋賀中国語教室 日中文化サロン守山</title>
          <meta
            name="google-site-verification"
            content="AIXw6z9YOE4agaazagJd4VrGxkYgdOOizi6Q9n811dg"
          />
        </Helmet>
        <LayoutOrg active="/">
          <ProfileOrg />
          <ContactMol />
        </LayoutOrg>
      </div>
    )
  }
}
